// Dutch
export default  {
    homeScreen : {
        startConversation: 'Start een gesprek',
        newConversationButton: 'KRIJG HULP',
        newMessageButton: '+ Nieuw bericht',
        allTopics: 'Alle onderwerpen',
        allChatsButton: 'Toon alles',
        poweredBy: 'Mede door Richpanel',
        reOpenConversation: 'Heropen gesprek',
        recentConversations: 'Recente gesprekken',
        startAChat: 'Begin een chat',
        noRecentConversations: 'Geen recente gesprekken',
        noRecentOrders: 'Geen recente bestellingen',
        haveAQuestion: "Heb je een vraag of wil je gedag zeggen? We horen het graag van je.",
        conversationClosed: `Dit gesprek is als beëindigd gemarkeerd. Mocht je nog verdere vragen hebben, heropen het gesprek`,
        retry: 'Opnieuw proberen',
        errorOccured: 'Er is een fout opgetreden bij het verwerken van uw verzoek.',
        successMessage: 'We hebben uw verzoek ontvangen en het team neemt binnenkort contact met u op {email}',
        loadingMessage: 'Wacht alsjeblieft. We dienen uw verzoek in.',
        goHome: 'OKE',
        sendUsMessage: 'zend ons een bericht',
        endChat: "EINDE GESPREK",
        goto: 'Ga naar',
    },

    loginScreen: {
        title: 'Log in op het helpcenter',
        titleForOrdersScreenForward: 'Log in om bestellingen te bekijken',
        userIdFieldTitle: "Uw telefoon of e-mail",
        userIdFieldPlaceHolder: "Voer telefoonnummer / e-mailadres in",
        sendCode: "ENTER",
        enterCode: 'Voer de code in die we hebben verzonden',
        enterTheCode: 'voer de code in',
        notYourUserId: 'Niet uw {userIdType}?',
        userIdTypes: {
            'phone': 'number',
            'email': 'email',
        },
        change: 'Verandering',
        notReceivedCode: "Heeft u de code niet ontvangen?",
        resendCode: 'Opnieuw versturen',
        in: 'in',
        verifyCode: 'VERIFIËREN',
        logout: 'Uitloggen',
        orderNumberFieldTitle: 'Uw bestellingsnummer',
        orderNumberFieldPlaceholder: 'Voer bestelnummer Ex: 1234 in',
        zipcodeFieldTitle: 'Uw pincode voor verzending',
        zipcodeFieldPlaceholder: 'Voer verzendpincode in',
        emailFieldTitle: 'E-mail',
        emailFieldPlaceholder: 'Voer email in',
    },

    orderList : {
        reorder: 'NABESTELLEN',
        getHelp: 'KRIJG HULP',
        startNewConversation: 'START EEN NIEW GESPREK',
        viewPreviousOrder:'BEKIJK ALLE BESTELLINGEN',
        seeAll: 'TOON ALLES',
        viewMoreOrders: 'ZIE MEER BESTELLINGEN',
        viewOrderStatus: 'ZIE STATUS BESTELLING',
        chatWithUs: 'CHAT MET ONS',
        issueWithPreviousOrder:'HELP MET VORIGE BESTELLINGEN' ,
        orderLabel: 'Bestelling',
        help: 'HELP',
        lastOrder: 'Laatste Bestelling',
        selectRelevantItems: 'Selecteer relevante artikelen',
        selectItemsErrorMsg: 'Selecteer items om door te gaan',
        selectAll: 'Selecteer alles',
        selectQuantity: 'Hoeveel artikelen?',
        helpWithThisOrder: 'Help met deze bestelling',
        yourOrders: 'Jouw bestelling',
        view: 'ZIE',
        track: 'VOLG',
        addressTitle: 'Bestelling overzicht',
        billingAddressTitle: 'FACTUURADRES',
        shippingAddressTitle: 'BESTELADRES',
        receiptTitle: 'artikelen',
        itemTotal: 'Totaal artikelen',
        taxes: 'Belasting',
        discounts: 'kortingen',
        giftCard: 'Gift Card', 
        deliveryCharges: 'Verzendkosten',
        total: 'Totaal',
        loginToViewOrders: 'Bestaande klant?',
        loginSuggestion: "Ontvang snelle hulp en bestelondersteuning",
        trackingOrderLabel: 'Order volgen',
        shipmentDescription: "Kom terug naar deze pagina voor updates over uw verzendstatus",
        free: "gratis",
        selectedItems: "Geselecteerde Voorwerpen",
        items: "Artikelen",
        "orderSearchPlaceholder": 'Filteren op bestelnummer',
        "noOrderFound": 'Geen overeenkomende bestellingen {orderId}',
    },
    chatListScreen: {
        header: 'Jouw gesprek',
    },
    sentences: {
        "IN_A_DAY" : "Het team reageert gebruikelijk binnen een dag.",
        "IN_FEW_MINUTES": "Het team reageert binnen een aantal minuten.",
        "IN_FEW_HOURS": "Het team reageert binnen een aantal uur.",
        "AS_SOON_AS_THEY_CAN": "Het team reageert zo snel mogelijk",
        "BACK_ON": "Weer aan",
        "BACK_IN": "Weer terug",
        "HOURS": "Uren",
        "MINUTES": 'Minuten',
        provideBelowDetails: "Geef de onderstaande details op",
    },
    inputFields: {
        submitted: 'ingediend'
    },
    inputPropDisplayNames: {
        "email": "E-mail",
        "phone": "Telefoon",
        "Phone": "Telefoon",
        "firstName": "Voornaam",
        "lastName": "Achternaam",
        "uid": "Gebruikersnaam",
        "campaign": "UTM Campaign",
        "medium": "UTM Medium",
        "googleplus": "Google plus",
        "shippingPhone": "Verzendadres telefoon",
        "source": "UTM Source",
        "lastOrderAt": "Laatste bestellingstijd",
        "firstOrderAt": "Eerste bestellingstijd",
        "visits": "Sessies",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Laatst gezien",
        "createdAt": "Eerst gezien",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Factuurmail",
        "billingPhone": "Factuurnnummer",
        "shippingEmail": "Verzendadres e-mail",
        "state": "Staat",
        "city": "Stad",
        "country": "Land",
        "deviceType": "Soort apparaat",
        "browserName": "Browser naam",
        "osName": "Os naam",
        "platform": "Platform",
        "ltv": "CLV",
        "ordersCount": "Aantal Bestellingen",
        "name": "Naam",
        "RichpanelPredictedCLV": "Predicted CLV",
        "RichpanelAliveProbability": "Likelihood To Buy",
        "RichpanelNextOrderDate": "Volgende bestellingsdatum",
        "RichpanelPredictedOrderCount": "Voorspelde hoeveelheid bestellingen",
        "aov": "AOV",
        "WebsiteURL":"Website url"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Ben je een bestaande klant?',
        YES_EXISITING_CUSTOMER: "Ja, ik ben een bestaande klant.",
        NO_EXISITING_CUSTOMER: "Nee, ik ben nog geen bestaande klant.",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Geef het team een mogelijkheid om jouw te benaderen.",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Je krijgt een hier een melding en op email ({email}) wanneer ze reageren.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Je krijgt hier een melding wanneer ze reageren",
        LEAVE_YOUR_MESSAGE: "Alstublieft, laat een bericht achter.",
        TEAM_WILL_BE_BACK_IN:"Het team is terug in {hours} uren",
        TEAM_WILL_BE_BACK_ON:"Het team is terug om {availableAt}",
        FEW_MORE_DETAILS: "Dankje! Nog een paar details zal je helpen om de juiste persoon te vinden",
    },
    initialForm: {
        heading: 'Alstublieft, vul je gegevens in om het gesprek te starten.',
        startChat: 'Start gesprek.'
    },
    customerJourneyPreChatForm: {
        heading:'Start een gesprek.',
        startChat: 'Start een gesprek.',
        proceed: 'Doorgaan',
        canWeHelpWithAnythingElse: 'Kunnen we iets anders helpen?',
        noThanks: "Nee, dank u wel",
        yesContactSupport: "Yes, chatten met ondersteuning",
        contactSupport: "contact opnemen met ondersteuning",
        yes: 'Ja',
        no: 'Nee',
    },
    rating: {
        askedHeader: 'Beoordeel het gesprek',
        successHeader: 'Gesprek is beoordeeld',
        thanksMessage: "Bedankt voor het laten weten",
        placeholderForRatingFeedback: "Alstublieft, schrijf jouw feedback"
    },
    placeholders: {
        emojiSearch: 'Emojis zoeken',
        typeAMessage: 'Schrijf een bericht',
        searchGifs: 'Zoek GIFs',
    },
    lastMessageText: {
        sentAGif: 'Stuur een GIF',
        sharedFile: 'Deel een bestand',
        askedForQualificationDetails: 'Kwalificatie details gevraagd.',
        askedForRating: 'Beoordeling gevraagd',
        askedForFeedback: 'Feedback gevraagd',
        sharedOrderSummary: "Deel overzicht van bestelling"
    },
    greetingAnimation: {
        weAreOnline: 'We zijn online',
        askUsAnything: 'Vraag ons alles',
        chatWithUs: 'Chat met ons'
    }
}